module.exports = __webpack_public_path__ + "img/img_map_sp@3x.62fdd9ad.png";